export function pisMask(value = '', defaultEmptyReturn = ''): string {
  if (!value) return defaultEmptyReturn

  return value.replace(/\D/g, '').replace(/(\d{3})(\d{5})(\d{2})(\d{1})+?$/, '$1.$2.$3-$4')
}
